// window.addEventListener("load", function () {

//   const banner = document.querySelector(".banner-splide");

//   if (!banner) return;

//   new Splide(banner,{
//     type:"fade",
//     rewind:true,
//     autoplay:true,
//     speed:600,
//     arrows:false,
//     pagination:false
//   }).mount();

// });

// document.addEventListener("DOMContentLoaded", function () {
//   const isCollection = document.body.classList.contains("template-collection");
//   const isProduct = document.body.classList.contains("template-product");

//   const STORAGE_PREFIX = "collection_scroll_position:";

//   /*
//    * Get the current collection key.
//    * The pathname and query string are included so sorting/query
//    * parameters are also considered.
//    */
//   function getCollectionKey() {
//     return STORAGE_PREFIX + window.location.pathname + window.location.search;
//   }

//   /*
//    * Remove all saved collection scroll positions.
//    */
//   function clearCollectionScrollPositions() {
//     const keysToRemove = [];

//     for (let i = 0; i < sessionStorage.length; i++) {
//       const key = sessionStorage.key(i);

//       if (key && key.indexOf(STORAGE_PREFIX) === 0) {
//         keysToRemove.push(key);
//       }
//     }

//     keysToRemove.forEach(function (key) {
//       sessionStorage.removeItem(key);
//     });
//   }

//   /*
//    * If the customer visits any page other than a Collection
//    * or Product page, destroy the saved collection position.
//    */
//   if (!isCollection && !isProduct) {
//     clearCollectionScrollPositions();
//     return;
//   }

//   /*
//    * Product page:
//    * Keep the saved collection position.
//    */
//   if (isProduct) {
//     return;
//   }

//   /*
//    * Collection page logic starts here.
//    */

//   const currentKey = getCollectionKey();

//   /*
//    * Save the current scroll position.
//    */
//   function saveScrollPosition() {
//     sessionStorage.setItem(
//       currentKey,
//       JSON.stringify({
//         scrollY: window.scrollY,
//         url: window.location.href
//       })
//     );
//   }

//   /*
//    * Save position while the customer is browsing.
//    * Debouncing prevents sessionStorage from being updated
//    * on every single scroll event.
//    */
//   let scrollTimer;

//   window.addEventListener(
//     "scroll",
//     function () {
//       clearTimeout(scrollTimer);

//       scrollTimer = setTimeout(function () {
//         saveScrollPosition();
//       }, 100);
//     },
//     { passive: true }
//   );

//   /*
//    * Save the position immediately before leaving
//    * the collection page.
//    */
//   window.addEventListener("pagehide", function () {
//     saveScrollPosition();
//   });

//   /*
//    * Restore the saved collection position.
//    */
//   function restoreScrollPosition() {
//     const savedData = sessionStorage.getItem(currentKey);

//     if (!savedData) {
//       return;
//     }

//     let savedState;

//     try {
//       savedState = JSON.parse(savedData);
//     } catch (error) {
//       sessionStorage.removeItem(currentKey);
//       return;
//     }

//     if (
//       !savedState ||
//       typeof savedState.scrollY !== "number"
//     ) {
//       sessionStorage.removeItem(currentKey);
//       return;
//     }

//     /*
//      * Restore after the collection content has rendered.
//      */
//     requestAnimationFrame(function () {
//       requestAnimationFrame(function () {
//         window.scrollTo({
//           top: savedState.scrollY,
//           left: 0,
//           behavior: "auto"
//         });

//         /*
//          * Destroy the saved position immediately after
//          * successfully restoring it.
//          */
//         sessionStorage.removeItem(currentKey);
//       });
//     });
//   }

//   /*
//    * pageshow handles normal loading as well as
//    * browser back/forward navigation, including Safari.
//    */
//   window.addEventListener("pageshow", function () {
//     restoreScrollPosition();
//   });

//   /*
//    * Also attempt restoration after the initial page load.
//    */
//   restoreScrollPosition();
// });



(function () {
  const STATE_KEY = "breadcrumb_collection_state";
  const RESTORE_KEY = "breadcrumb_restore_state";

  function isIOS() {
    return (
      /iPhone|iPad|iPod/i.test(navigator.userAgent) ||
      (navigator.platform === "MacIntel" &&
        navigator.maxTouchPoints > 1)
    );
  }

  function isTablet() {
    return (
      /iPad|Tablet|Android(?!.*Mobile)/i.test(navigator.userAgent) ||
      (navigator.maxTouchPoints > 1 && window.innerWidth >= 600)
    );
  }

  function useDirectRestore() {
    return isIOS() || isTablet();
  }

  function getState(key) {
    try {
      const value = sessionStorage.getItem(key);
      return value ? JSON.parse(value) : null;
    } catch (error) {
      return null;
    }
  }

  function saveState(key, value) {
    try {
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      // Continue normal navigation if sessionStorage is unavailable.
    }
  }

  function removeState(key) {
    try {
      sessionStorage.removeItem(key);
    } catch (error) {
      // Ignore storage errors.
    }
  }

  function init() {
    const isCollection = document.body.classList.contains(
      "template-collection"
    );

    const isProduct = document.body.classList.contains(
      "template-product"
    );

    if (!isCollection && !isProduct) return;

    // COLLECTION PAGE
    if (isCollection) {
      const restore = getState(RESTORE_KEY);

      if (
        restore &&
        restore.pathname === location.pathname &&
        restore.search === location.search &&
        Number.isFinite(restore.scrollY)
      ) {
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            window.scrollTo(0, restore.scrollY);

            removeState(RESTORE_KEY);
            removeState(STATE_KEY);
          });
        });
      } else if (restore) {
        removeState(RESTORE_KEY);
      }

      // Save collection URL and scroll position when opening a product.
      document.addEventListener(
        "click",
        function (event) {
          const element = event.target;

          if (!element || !element.closest) return;

          const link = element.closest(
            '#product-grid a[href*="/products/"], ' +
            '.product-grid a[href*="/products/"], ' +
            'a.full-unstyled-link[href*="/products/"]'
          );

          if (!link || event.defaultPrevented) return;

          if (
            event.button !== 0 ||
            event.metaKey ||
            event.ctrlKey ||
            event.shiftKey ||
            event.altKey
          ) {
            return;
          }

          const productUrl = new URL(link.href, location.origin);

          if (productUrl.origin !== location.origin) return;

          saveState(STATE_KEY, {
            url: location.pathname + location.search,
            pathname: location.pathname,
            search: location.search,
            scrollY: window.scrollY
          });
        },
        true
      );

      return;
    }

    // PRODUCT PAGE
    // Intercept only the Collection breadcrumb.
    if (isProduct) {
      document.addEventListener(
        "click",
        function (event) {
          const element = event.target;

          if (!element || !element.closest) return;

          const link = element.closest(
            ".breadcrumbs a[href*='/collections/'], " +
            ".breadcrumb a[href*='/collections/'], " +
            "a[href*='/collections/']"
          );

          if (!link) return;

          if (
            event.button !== 0 ||
            event.metaKey ||
            event.ctrlKey ||
            event.shiftKey ||
            event.altKey
          ) {
            return;
          }

          const state = getState(STATE_KEY);

          // If no saved collection state exists, let the link work normally.
          if (!state || !state.url) return;

          const clickedUrl = new URL(link.href, location.origin);
          const savedUrl = new URL(state.url, location.origin);

          if (
            clickedUrl.origin !== location.origin ||
            clickedUrl.pathname !== savedUrl.pathname
          ) {
            return;
          }

          // Prevent the breadcrumb's default navigation only when
          // a matching saved collection state is available.
          event.preventDefault();

          if (!useDirectRestore()) {
            // Desktop and Android: use browser history.
            if (history.length > 1) {
              history.back();
            } else {
              window.location.href = state.url;
            }

            return;
          }

          // iPhone and tablets: navigate directly and restore position.
          saveState(RESTORE_KEY, {
            pathname: savedUrl.pathname,
            search: savedUrl.search,
            scrollY: state.scrollY
          });

          window.location.href = state.url;
        },
        true
      );
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();


document.addEventListener("DOMContentLoaded", function () {
  const banner = document.querySelector(".banner-splide");
  if (banner) {

    const splide = new Splide(banner, {
      type: "fade",
      rewind: true,
      autoplay: false,
      speed: 600,
      arrows: false,
      pagination: false
    });

    splide.mount();

    window.addEventListener("load", function () {
      splide.options = {
        autoplay: true,
        interval: 5000
      };

      splide.Components.Autoplay.play();
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {

  if (document.querySelector(".home_collection_list")) {

    document.querySelectorAll(".collection-splide").forEach(function (splideEl) {

      const splide = new Splide(splideEl, {
        perPage: 4,
        gap: 30,
        arrows: false,
        pagination: false,

        breakpoints: {
          1280: { perPage: 4 },
          1024: { 
            perPage: 3,
            gap: 15
           },
          640: { perPage: 2,
                 gap: 10
           }
        }
      });

      const wrapper = splideEl.closest(".collection_slider_wrapper");
      const prevBtn = wrapper.querySelector(".collection-prev");
      const nextBtn = wrapper.querySelector(".collection-next");

      splide.mount();

      if (prevBtn && nextBtn) {

        prevBtn.style.display = "flex";
        nextBtn.style.display = "flex";

        prevBtn.addEventListener("click", function () {
          splide.go("<");
        });

        nextBtn.addEventListener("click", function () {
          splide.go(">");
        });

        function updateArrows() {

          const index = splide.index;
          const end = splide.length - splide.options.perPage;

          if (index <= 0) {
            prevBtn.classList.add("disabled");
            prevBtn.setAttribute("disabled", "disabled");
          } else {
            prevBtn.classList.remove("disabled");
            prevBtn.removeAttribute("disabled");
          }

          if (index >= end) {
            nextBtn.classList.add("disabled");
            nextBtn.setAttribute("disabled", "disabled");
          } else {
            nextBtn.classList.remove("disabled");
            nextBtn.removeAttribute("disabled");
          }

        }

        splide.on("mounted moved", updateArrows);

      }

    });

  }

});

document.addEventListener("DOMContentLoaded", function () {
  // if (document.querySelector(".banner-splide")) 
  // {
  //   new Splide(".banner-splide", {
  //     type: "fade",
  //     rewind: true,
  //     autoplay: false,
  //     interval: 5000,
  //     speed: 600,
  //     pauseOnHover: false,
  //     arrows: false,
  //     pagination: false
  //   }).mount();

  // }

if (document.querySelector(".custom_video")) {

  const wrapper = document.querySelector(".video_wrapper");
  const video = wrapper.querySelector(".custom_video");
  const playBtn = wrapper.querySelector(".play_btn");
  const pauseBtn = wrapper.querySelector(".pause_btn");

  function isMobile() {
    return window.innerWidth <= 768;
  }

  function updateButtons() {

    if (video.paused) {
      playBtn.style.display = "flex";
      pauseBtn.style.display = "none";
      wrapper.classList.remove('showvid-icon');
      
    } else {
      playBtn.style.display = "none";
      wrapper.classList.add('showvid-icon');

      if (!isMobile()) {
        pauseBtn.style.display = "none"; // shown only on hover desktop
      }
    }

  }

  function toggleVideo() {

    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }

    updateButtons();
  }

  /* Play button */
  playBtn.addEventListener("click", function(e){
    e.stopPropagation();
    toggleVideo();
  });

  /* Pause button (desktop only) */
  pauseBtn.addEventListener("click", function(e){
    e.stopPropagation();
    toggleVideo();
  });

  /* Mobile tap on video to pause */
  video.addEventListener("click", function(){
    if (isMobile() && !video.paused) {
      video.pause();
      updateButtons();
    }
  });

  /* Desktop hover show pause */
  wrapper.addEventListener("mouseenter", function () {

    if (!isMobile() && !video.paused) {
      pauseBtn.style.display = "flex";
    }

  });

  /* Desktop hover hide pause */
  wrapper.addEventListener("mouseleave", function () {

    if (!isMobile() && !video.paused) {
      pauseBtn.style.display = "none";
    }

  });

  /* When video ends */
  video.addEventListener("ended", function () {

    video.pause();
    video.currentTime = 0;

    playBtn.style.display = "flex";
    pauseBtn.style.display = "none";

  });

}



window.SplideSliderFunction = function () {
  document.querySelectorAll('.recom-slider').forEach((element) => {
    const perPage = parseInt(element.dataset.perPage) || 1;
    const gap = element.dataset.gap || '24px';
    const drag = element.dataset.drag === 'true';
    const arrows = element.dataset.arrows === 'true';
    const direction = element.dataset.direction;
    const height = element.dataset.height;
    const autoplay = element.dataset.autoplay === 'true';
    const autoplayintervel = parseInt(element.dataset.autoplayintervel);
    const type = element.dataset.type;
    const paginatione = element.dataset.pagination == 'true';
    
    // Banner check
    const isBanner = element.dataset.banner === 'yes';
    const mobileshow = isBanner ? 1 : 2;

   
    const splide = new Splide(element, {
      type: type,
      perPage: perPage,
      arrows: arrows,
      pagination: paginatione,
      drag: drag,
      autoplay: autoplay,
      gap: gap,
      interval: autoplayintervel || 3000,
      breakpoints: {
        989: {
          pagination: paginatione,
          drag: true,
          perPage: mobileshow,
          gap: "20px"
        },
        767: {
          perPage: mobileshow,
          arrows: arrows,
          pagination: paginatione,
        },
        575: {
          perPage: 1,
          arrows: arrows,
          pagination: paginatione
        }
      }
    });

splide.on('mounted move resized', function () {

  const totalSlides = splide.length;
  const index = splide.index;
  const perPage = splide.options.perPage;
  const lastIndex = totalSlides - perPage;

  const prevArrow = element.querySelector('.splide__arrow--prev');
  const nextArrow = element.querySelector('.splide__arrow--next');

  if (!prevArrow || !nextArrow) return;

  // Hide arrows if all slides fit
  if (totalSlides <= perPage) {
    prevArrow.style.display = 'none';
    nextArrow.style.display = 'none';
    return;
  } else {
    prevArrow.style.display = '';
    nextArrow.style.display = '';
  }

  // Reset disabled state
  prevArrow.classList.remove('disabled');
  nextArrow.classList.remove('disabled');

  // Disable prev at first slide
  if (index === 0) {
    prevArrow.classList.add('disabled');
  }

  // Disable next at last slide
  if (index >= lastIndex) {
    nextArrow.classList.add('disabled');
  }

});

splide.mount();
    
    
  });
  
};

SplideSliderFunction();

window.TestimonialSliderFunction = function () {
  document.querySelectorAll('.test-slider').forEach((element) => {
    const perPage = parseInt(element.dataset.perPage) || 1;
    const gap = element.dataset.gap || '24px';
    const drag = element.dataset.drag === 'true';
    const arrows = element.dataset.arrows === 'true';
    const direction = element.dataset.direction;
    const height = element.dataset.height;
    const autoplay = element.dataset.autoplay === 'true';
    const autoplayintervel = parseInt(element.dataset.autoplayintervel);
    const type = element.dataset.type;
    const paginatione = element.dataset.pagination == 'true';
    
    // Banner check
    const isBanner = element.dataset.banner === 'yes';
    const mobileshow = isBanner ? 1 : 2;

   
    const testsplide = new Splide(element, {
      type: type,
      perPage: perPage,
      arrows: arrows,
      pagination: paginatione,
      drag: drag,
      autoplay: autoplay,
      gap: gap,
      focus: "center",
      interval: autoplayintervel || 3000,
      breakpoints: {
        989: {
          pagination: paginatione,
          drag: true,
          perPage: mobileshow,
          gap: "20px"
        },
        767: {
          perPage: mobileshow,
          arrows: arrows,
          pagination: paginatione,
        },
        575: {
          perPage: 1,
          arrows: arrows,
          pagination: paginatione
        }
      }
    });

testsplide.on('mounted move resized', function () {

  const totalSlides = testsplide.length;
  const index = testsplide.index;
  const perPage = testsplide.options.perPage;
  const lastIndex = totalSlides - perPage;

  const prevArrow = element.querySelector('.splide__arrow--prev');
  const nextArrow = element.querySelector('.splide__arrow--next');

  if (!prevArrow || !nextArrow) return;

  // Hide arrows if all slides fit
  if (totalSlides <= perPage) {
    prevArrow.style.display = 'none';
    nextArrow.style.display = 'none';
    return;
  } else {
    prevArrow.style.display = '';
    nextArrow.style.display = '';
  }

  // Reset disabled state
  prevArrow.classList.remove('disabled');
  nextArrow.classList.remove('disabled');

  // Disable prev at first slide
  if (index === 0) {
    prevArrow.classList.add('disabled');
  }

  // Disable next at last slide
  if (index >= lastIndex) {
    nextArrow.classList.add('disabled');
  }

});

testsplide.mount(window.splide.Extensions);
    
    
  });
  
};

TestimonialSliderFunction();

window.addEventListener('scroll', function () {
  if (window.scrollY > 50) {
    document.body.classList.add('sticky_menu');
  } else {
    document.body.classList.remove('sticky_menu');
  }
});


});


document.addEventListener("DOMContentLoaded", function () {

  if (document.querySelector(".custom_login_popup_section")) {

    const loginIcon = document.querySelector(".custom_login_icon");
    const mloginIcon = document.querySelector(".mobile_custom_login_icon");
    const closeBtn = document.querySelector(".lg_popup_cl_btn");
    const popupBtn = document.querySelector(".lg_popup_btn");
    const defaultLogin = document.querySelector(".default_login_link");
    const popup = document.querySelector(".custom_login_popup_section");
    const overlay = document.querySelector(".overlay");
    const body = document.body;

    loginIcon?.addEventListener("click", function () {
      popup.classList.add("popup_show");
      popup.classList.remove("popup_hide");
      body.classList.add("popup_enabled");
    });

    mloginIcon?.addEventListener("click", function () {
      popup.classList.add("popup_show");
      popup.classList.remove("popup_hide");
      body.classList.add("popup_enabled");
    });

    closeBtn?.addEventListener("click", function () {
      popup.classList.add("popup_hide");
      popup.classList.remove("popup_show");
      body.classList.remove("popup_enabled");
    });

    popupBtn?.addEventListener("click", function () {
      defaultLogin?.click();
    });

    overlay?.addEventListener("click", function () {
      popup.classList.add("popup_hide");
      popup.classList.remove("popup_show");
      body.classList.remove("popup_enabled");
    });

  }

});

document.addEventListener("DOMContentLoaded", function () {

    if (!document.querySelector(".template-product")) return;

    function handleVideoLoader(slide) {

        if (!slide) return;

        const video = slide.el.querySelector("video");

        if (!video) return;

        const loader = slide.el.querySelector(".video-loading");

        // Show loader whenever we enter a video slide
        if (loader) {
            loader.classList.remove("is-hidden");
        }

        function hideLoader() {

            if (loader) {
                loader.classList.add("is-hidden");
            }

            video.removeEventListener("play", hideLoader);
            video.removeEventListener("playing", hideLoader);
        }

        // Video already started
        if (!video.paused) {
            hideLoader();
            return;
        }

        video.addEventListener("play", hideLoader, { once: true });
        video.addEventListener("playing", hideLoader, { once: true });
    }

    function waitForVideo(slide) {

        const timer = setInterval(() => {

            const video = slide.el.querySelector("video");
            const loader = slide.el.querySelector(".video-loading");

            if (!video || !loader) {
                return;
            }

            clearInterval(timer);

            handleVideoLoader(slide);

        }, 20);

    }

    const mediaItems = document.querySelectorAll(".product__media-item");
    const fancyItems = [];

    mediaItems.forEach(function (item) {

        const container = item.querySelector(".product-media-container");

        if (!container) return;

        const type = container.dataset.mediaType;

        let imageUrl = container.dataset.imageUrl || "";
        let videoUrl = container.dataset.videoUrl || "";

        if (imageUrl.startsWith("//")) {
            imageUrl = "https:" + imageUrl;
        }

        if (videoUrl.startsWith("//")) {
            videoUrl = "https:" + videoUrl;
        }

        if (type === "video") {

            fancyItems.push({
                src: videoUrl,
                type: "html5video",
                thumb: imageUrl,
                html: '<div class="video-loading"></div>'
            });

        } else {

            fancyItems.push({
                src: imageUrl,
                type: "image",
                thumb: imageUrl
            });

        }

    });

    mediaItems.forEach(function (item, index) {

        const preview = item.querySelector(".product__media img");

        if (preview) {
            preview.style.cursor = "zoom-in";
        }

        item.addEventListener("click", function (e) {

            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            Fancybox.show(fancyItems, {

                startIndex: index,

                Toolbar: {
                    display: ["close"]
                },

                Carousel: {
                    infinite: true
                },

                Images: {
                    Panzoom: {
                        maxScale: 3
                    }
                },

                dragToClose: false,

                on: {
                  ready: (fb) => {

                      // Wait until the first slide has been rendered
                      setTimeout(() => {
                          handleVideoLoader(fb.getSlide());
                      }, 10);

                  },
                   reveal: (fancybox, slide) => {
                      const video = slide.el?.querySelector("video");
                      if (video) {
                          video.removeAttribute("controls");
                      }
                  },
                  "Carousel.change": (fb) => {
                      setTimeout(() => {
                          handleVideoLoader(fb.getSlide());
                      }, 10);
                  }
              }

            });

        });

    });

    const observer = new MutationObserver(function () {

        const zoomed = document.querySelector(".f-panzoom__wrapper.is-expanded");

        document.body.classList.toggle("fancybox_zoomed", !!zoomed);

    });

    observer.observe(document.body, {
        subtree: true,
        attributes: true,
        attributeFilter: ["class"]
    });

});

document.addEventListener('DOMContentLoaded', function () {
    if (!document.body.classList.contains('template-product')) {
        return;
    }

    const thumbnails = document.querySelectorAll('.thumbnail-list__item');
    const prevButton = document.querySelector('.custom-prev');
    const nextButton = document.querySelector('.custom-next');

    if (!thumbnails.length || !prevButton || !nextButton) {
        return;
    }

    thumbnails.forEach(function (thumbnail, index) {
        thumbnail.addEventListener('click', function () {
            const totalThumbnails = thumbnails.length;

            // First thumbnail
            if (index === 0) {
                prevButton.classList.add('disabled');
                nextButton.classList.remove('disabled');
            }
            // Last thumbnail
            else if (index === totalThumbnails - 1) {
                prevButton.classList.remove('disabled');
                nextButton.classList.add('disabled');
            }
            // Any thumbnail between first and last
            else {
                prevButton.classList.remove('disabled');
                nextButton.classList.remove('disabled');
            }
        });
    });
});